/* eslint-disable react/jsx-indent */
/* eslint-disable prettier/prettier */
import React, { useCallback, useEffect, useState } from 'react';
import {
  FaDownload,
  FaExclamationCircle,
  FaFilePdf,
  FaShareSquare,
  FaSpinner,
  FaTrashAlt,
} from 'react-icons/fa';

import socket from '../../services/socket';

import { useAuth } from '../../hooks/auth';
import { useNotaFiscal } from '../../hooks/notafiscal';
import { useToast } from '../../hooks/toast';
import { INotafiscal } from '../../pages/Nota/Relatorio';
import api from '../../services/api';
import getResponseErrors from '../../utils/getResponseErrors';
import { Spinner } from '../Agendamento/styles';
import DadosNota from '../DadosNota';
import Loading from '../Loading';
import Modal from '../Modal';
import { SITUACAO_NOTA_FISCAL } from '../../utils/funcoes';

// import { Container } from './styles';

export interface ISituacaoNota {
  NfeNumero?: string;
  NfeSerie?: string;
  NfeSituacao?: string;
  NfeMessage?: string;
  NfeNumeroNFSe?: string;
  NfeLinkNFSe?: string;
  NfeArquivo?: string;
  NfeDataEmissao?: Date;
  NfeValorNota?: number;
  NfeCodigoVerificacao?: string;
  linkNota?: string;
  NfeCprCodigo?: number;
  NfeId?: string;
}

type Props = {
  cprCodigo: number;
  nfeId?: string;
  dadosNota?: ISituacaoNota;
  podeCancelar?: boolean;
};

const ControlesNotaFiscal: React.FC<Props> = ({
  cprCodigo,
  nfeId,
  dadosNota,
  podeCancelar,
}) => {
  const { addToast } = useToast();
  const { clinica } = useAuth();
  const { setNotaFiscal } = useNotaFiscal();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalCancelar, setShowModalCancelar] = useState<boolean>(false);
  const [situacao, setSituacao] = useState<ISituacaoNota | undefined>({
    ...dadosNota,
    NfeCprCodigo: dadosNota?.NfeCprCodigo || cprCodigo,
    NfeId: dadosNota?.NfeId || nfeId || cprCodigo.toString(),
  });

  useEffect(() => {
    const handleNewMessage = (data: INotafiscal): void => {
      setNotaFiscal(data);
    };

    socket.on('notaFiscal', handleNewMessage);
    return () => {
      socket.removeEventListener('notaFiscal', handleNewMessage);
    };
  }, [setNotaFiscal]);

  useEffect(() => {
    async function loadSituacao(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<ISituacaoNota>(
          `/notafiscal/situacao/${nfeId || cprCodigo}`,
        );

        const notasFormatadas = {
          ...response.data,
          linkNota:
            response.data.NfeLinkNFSe &&
              response.data.NfeLinkNFSe.includes('google')
              ? response.data.NfeLinkNFSe
              : response.data.linkNota,
        };
        setSituacao(notasFormatadas);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar dados de situação da nota fiscal',
          type: 'error',
          description: mensagemErro,
        });
      }
      setLoading(false);
    }

    if (!dadosNota) {
      loadSituacao();
    } else {
      setSituacao(dadosNota);
    }
  }, [addToast, cprCodigo, dadosNota, nfeId]);

  const baixarPDF = useCallback(
    async NfeId => {
      try {
        await api.put(`emissaonfse/consultaNFSE/${NfeId}`);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível baixar PDF',
          type: 'error',
          description: mensagemErro,
        });
      }
    },
    [addToast],
  );

  const verificaSituacao = useCallback(
    async NfeId => {
      try {
        await api.put(`emissaonfse/consultaNFSE/${NfeId}`);
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi verificar situação',
          type: 'error',
          description: mensagemErro,
        });
      }
    },
    [addToast],
  );

  const cancelarNota = useCallback(async () => {
    try {
      await api.delete(`emissaonfse/cancelar/${nfeId}`);
      if (dadosNota) setSituacao({ ...dadosNota, NfeSituacao: 'Cancelado' });
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível cancelar a nota',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setShowModalCancelar(false);
    }
  }, [addToast, nfeId, dadosNota]);

  return (
    <>
      {loading && <Loading backgroundBlack={false} />}
      {showModalCancelar && (
        <Modal
          titulo="Cancelar Nota Fiscal"
          show={showModalCancelar}
          large={false}
          // className="mt-4"
          handleFecharModal={() => setShowModalCancelar(false)}
        >
          <div className="text-center">
            <FaExclamationCircle size={48} color="#dc3545" />
            <h6>
              Atenção, essa operação irá CANCELAR a Nota Fiscal.
              <br />
              <br />
              ESTE PROCESSO É IRREVERSÍVEL, deseja continuar?
            </h6>
            {/* <p>
              Todos os registros e histórico serão apagados. Operação só pode
              ser feita caso não exista registro de pagamentos.
            </p> */}
            <div className="d-flex justify-content-between mt-4">
              <button
                type="button"
                className="btn btn-sm btn-info float-right ml-2"
                onClick={() => setShowModalCancelar(false)}
                disabled={loading}
              >
                Não, voltar
              </button>

              <button
                type="button"
                className="btn btn-sm btn-outline-danger float-right ml-2"
                // size="sm"
                onClick={() => cancelarNota()}
                disabled={loading}
              >
                {loading ? 'confirmando... ' : 'Sim, confirmar'}
              </button>
            </div>
          </div>
        </Modal>
      )}
      <div className="d-flex justify-content-end">
        {situacao && situacao.NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.EMITIDA && !situacao.linkNota && (
          <button
            type="button"
            id={`link${situacao.NfeNumero}-${situacao.NfeId}`}
            title="Gerar PDF"
            className="btn btn-sm btn-outline-success mr-2"
            onClick={() => baixarPDF(situacao.NfeNumero)}
          >
            <FaDownload id={`ilink${situacao.NfeNumero}-${situacao.NfeId}`} />
          </button>
        )}
        {situacao && situacao.linkNota && (
          <a
            href={situacao.linkNota || ''}
            title="Ver NF"
            target="_blank"
            rel="noopener noreferrer"
            style={{ width: '34px' }}
            className="btn btn-sm btn-outline-primary"
            id={`dw-${situacao.NfeNumero}-${situacao.NfeId}`}
          >
            <FaFilePdf
              id={`idwEmite-${situacao.NfeNumero}-${situacao.NfeId}`}
            />
          </a>
        )}
        {situacao && situacao.NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.EMITIDA && podeCancelar && (
          <button
            type="button"
            id={`cance-${situacao.NfeNumero}-${situacao.NfeId}`}
            title="Cancelar"
            className="btn btn-sm btn-outline-danger  ml-2"
            onClick={() => setShowModalCancelar(true)}
          >
            <FaTrashAlt id={`icancela-${situacao.NfeNumero}-${situacao.NfeId}`} />
          </button>
        )}
        {situacao &&
          situacao.NfeSituacao?.toLowerCase().includes(SITUACAO_NOTA_FISCAL.PROCESSANDO) && (
            <button
              type="button"
              id={`Verifica${situacao.NfeNumero}-${situacao.NfeId}`}
              title="Verificar Situação"
              className="btn btn-sm btn-outline-primary"
              onClick={() => verificaSituacao(situacao.NfeNumero)}
            >
              <Spinner>
                <FaSpinner />
              </Spinner>
            </button>
          )}
        {situacao &&
          (situacao.NfeNumero === undefined || situacao.NfeNumero === null ||
            ((situacao.NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.REJEITADO ||
              situacao.NfeSituacao?.toLowerCase() === SITUACAO_NOTA_FISCAL.CANCELADO) &&
              situacao.NfeSituacao?.includes(SITUACAO_NOTA_FISCAL.PROCESSANDO) === false)) && (
            <button
              type="button"
              id={`Emite-${cprCodigo.toString()}-${situacao.NfeId}`}
              className="btn btn-sm btn-outline-primary"
              onClick={() => setShowModal(true)}
              title="Emitir Nota fiscal"
              disabled={!clinica.CliEmiteNotaFiscal}
            >
              <FaShareSquare
                id={`IEmite-${cprCodigo.toString()}-${situacao.NfeId}`}
              />
            </button>
          )}
        {showModal && (
          <Modal
            show={showModal}
            titulo=" Dados da Nota Fiscal"
            handleFecharModal={() => setShowModal(false)}
          >
            <div>
              <DadosNota
                codigo={String(cprCodigo)}
                handleFecharModal={() => setShowModal(false)}
              />
            </div>
          </Modal>
        )}
      </div>
    </>
  );
};

export default ControlesNotaFiscal;
